import { render } from "./SerialDetail.vue?vue&type=template&id=0119c3b4&scoped=true"
import script from "./SerialDetail.vue?vue&type=script&lang=js"
export * from "./SerialDetail.vue?vue&type=script&lang=js"

import "./SerialDetail.vue?vue&type=style&index=0&id=0119c3b4&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0119c3b4"]])

export default __exports__